module.exports = __webpack_public_path__ + "media/promo/lum2021/images/contest-228069f62232d69c2459f066b2816f9d.png";